
export const Role = {
    Internal: {
        AssetProtection: "InternalAssetProtection",
        Procurement: "InternalProcurement",
        Admin: "InternalAdmin",
        Standard: "InternalStandard",
        Commercial: "InternalCommercial"
    },
    External: "External"
};
